/* eslint-disable */
export async function MensagensProntasFinalizarProtocolo() {
  return `👩🏻 Oi, sou a Paula novamente, vim para te avisar que o seu atendimento com nosso time de especialistas foi finalizado, se ainda precisar de ajuda é só digitar uma da opções enviadas anteriormente.`
}
